import axios from "axios";
import {getToken} from "./TokenRepository";

const createConfig = () => {
    return {
        headers: {
            'Api-Key': `Bearer ${getToken()}`
        },
    };
}

export const getAdminServiceTypes = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/serviceTypes`, createConfig());
    return response.data;
}

export const getPermissionRepositoryTypes = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/permissionRepositoryTypes`, createConfig());
    return response.data;
}

export const getServiceType = async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/${id}`, createConfig());
    return response.data;
}

export const createServiceType = async (serviceTypeName, permissionRepositoryType) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/serviceTypes`, {
        serviceTypeName, permissionRepositoryType
    }, createConfig());
    return response.data;
}

export const setServiceTypeName = async (id, serviceTypeName) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/setName/${id}`, {
        serviceTypeName
    }, createConfig());
    return response.data;
}

export const setServiceTypeDisabled = async (id, disabled) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/setDisabled/${id}`, {
        disabled
    }, createConfig());
    return response.data;
}

export const createService = async (serviceTypeId, serviceName, serviceAdditionalInformation) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/${serviceTypeId}/services`, {
        serviceName, serviceAdditionalInformation
    }, createConfig());
    return response.data;
}

export const updateService = async (serviceId, serviceName, serviceAdditionalInformation) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/serviceTypes/services/update/${serviceId}`, {
        serviceName, serviceAdditionalInformation
    }, createConfig());
    return response.data;
}
